import objectAssign from 'object-assign';
import 'whatwg-fetch';

const SUCCESS = 'dr-kiandra/subscriptions/success';
const FAILURE = 'dr-kiandra/subscriptions/failure';

const initialState = {
    status: 'none'
};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case SUCCESS:
            return objectAssign(
                {},
                state,
                { status: 'success' }
            );
        case FAILURE:
            return objectAssign(
                {},
                state,
                { status: 'failure' }
            );
        default:
            return state;
    }
}

export function subscribeSuccess() {
  return { type: SUCCESS };
}

export function subscribeFailure() {
  return { type: FAILURE };
}

export function subscribe(name, email) {
    let uri = 'https://drkiandra.us13.list-manage.com/subscribe/post?';
    uri = uri + 'u=477d87c570818653b413bf383&id=1c606395f3';
    uri = uri + '&FNAME=' + name;
    uri = uri + '&EMAIL=' + email;
    uri = uri + '&b_477d87c570818653b413bf383_1c606395f3=';
    uri = uri + '&subscribe=Subscribe';

    return new Promise(function(resolve, reject) {
        fetch(uri, { mode: 'no-cors', method: 'get' });
        resolve();
    });
}



/** WEBPACK FOOTER **
 ** ./src/modules/subscriptions.js
 **/